<header class="container-fluid header">
  <div class="row align-items-center">
    <div class="col-auto pe-0 left">
      <img
        class="img-fluid header-logo"
        src="/assets/images/vive-logo-white.svg"
        alt="VIVE"
      />
    </div>

    <div class="col"></div>

    @if (isVendorUser() && isUserLoggedIn() && isVendorRegistration) {
      <div class="col-auto me-4 cursor-select" (click)="goToVendorDashboard()">
        <div class="row align-items-center">
          <div class="col pe-0">
            <i class="fs-32 bi bi-speedometer" ngbTooltip="Dashboard"></i>
          </div>
        </div>
      </div>
    }
    @if (isVendorUser()) {
      <div class="col-auto help-container" ngbDropdown>
        <div
          ngbDropdownToggle
          class="cursor-select d-flex flex-column align-items-center justify-content-center"
        >
          <div class="lh-1 mt-1">
            <i class="fs-32 bi bi-question-circle" ngbTooltip="Help"></i>
          </div>
          <div></div>
        </div>
        <div ngbDropdownMenu>
          <button ngbDropdownItem (click)="openHelpCenter()">
            Help Center
          </button>
          <button ngbDropdownItem (click)="openLiveChat()">Chat</button>
        </div>
      </div>
    }

    @if (isUserLoggedIn() && !isVendorRegistration) {
      <div class="col-auto cursor-select" (click)="goToUserPage()">
        <i class="fs-32 bi-person-circle" ngbTooltip="User"></i>
      </div>
    }
    @if (isUserLoggedIn()) {
      @if (isImpersonating()) {
        <div
          class="col-auto me-4 cursor-select"
          role="button"
          tabindex="0"
          aria-label="Return to my account"
          (click)="returnToMyAccount()"
          (keydown.enter)="returnToMyAccount()"
        >
          <div class="row align-items-center">
            <div class="col pe-0">
              <i
                class="fs-32 bi-arrow-return-left"
                ngbTooltip="Return to my account"
              ></i>
            </div>
          </div>
        </div>
      } @else {
        <div class="col-auto me-4 cursor-select" (click)="logout()">
          <div class="row align-items-center">
            <div class="col pe-0">
              <i class="fs-32 bi-box-arrow-right" ngbTooltip="Logout"></i>
            </div>
          </div>
        </div>
      }
    }

    @if (showToggleIcon) {
      <div class="col-auto">
        <i class="bi bi-list" (click)="toggleMenu()"></i>
      </div>
    }
  </div>
</header>
@if (isImpersonating()) {
  <div class="impersonation-banner alert alert-warning" role="status">
    <span>You're viewing VIVE as {{ impersonationTargetName() }}.</span>
    <button
      type="button"
      class="btn btn-sm btn-outline"
      (click)="returnToMyAccount()"
    >
      Return to my account
    </button>
  </div>
}
